<template>
   <div class="wizard-create-account">
        <div class="text-center mt-12 mb-8">
            <h3>{{$trans.get('wizard.step3.title')}}</h3>
            <p class="mt-4">{{$trans.get('wizard.step3.subtitle')}}</p>
        </div>
        <div class="form-account">
            <floating-input
                class=""
                name="name"
                :placeholder="$trans.get('wizard.step3.name')"
                type="text"
                :initial-value="user.name"
                @input="user.name = $event"
            ></floating-input>
            <span class="m-0 text-sm text-red">{{errors.name}}</span>
            <floating-input
                class="mt-6"
                name="email"
                :placeholder="$trans.get('wizard.step3.email')"
                type="email"
                :initial-value="user.email"
                @input="user.email = $event"
            ></floating-input>
            <span class="m-0 text-sm text-red">{{errors.email}}</span>
            <floating-input
                class="mt-6"
                name="confirm-email"
                :placeholder="$trans.get('wizard.step3.confirm-email')"
                type="email"
                v-model="user.confirmEmail"
            ></floating-input>
            <span class="m-0 text-sm text-red">{{errors.confirmEmail}}</span>
            <floating-input
                class="mt-6"
                name="phone"
                :placeholder="$trans.get('wizard.step3.phone')"
                type="tel"
                :initial-value="user.phone"
                @input="user.phone = $event"
            ></floating-input>
            <span class="m-0 text-sm text-red">{{errors.phone}}</span>
            <div class="flex justify-center mt-8">
                <input id="privacy" v-model="privacyConsent" class="form-check-input" type="checkbox">
                <label for="privacy" class="form-check-label text-small relative">
                    <p class="text-left mb-2 pr-2">
                        {{ $trans.get('wizard.step3.privacy-consent') }}
                        <a :href="privacyConsentLink" target="_blank" class="underline">{{ $trans.get('wizard.step3.privacy-consent-link') }}</a>.
                    </p>
                </label>
            </div>
            <button :disabled="buttonIsDisabled" @click="submmitform()" class="btn btn-secondary w-full mt-6" :class="{'disabled': buttonIsDisabled}">
                {{$trans.get('wizard.step3.button')}}
            </button>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            user:{
                name:'',
                email:'',
                confirmEmail:'',
                phone: ''
            },
            errors:{
                name:'',
                email:'',
                confirmEmail:'',
                phone: ''
            },
            privacyConsent: false,
            valid: false,
        }
    },
    computed: {
        privacyConsentLink() {
            return window.appLocale === 'es' ? '/es/politica-de-privacidad' : '/ca/politica-de-privacitat';
        },
        buttonIsDisabled() {
            return !this.valid || !this.privacyConsent;
        }
    },
    watch:{
        'user.name': 'validname',
        'user.phone': 'validphone',
        'user.email': 'validemail',
        'user.confirmEmail': 'validateEmailConfirmation'
    },
    methods: {
        validname(){
            this.errors.name = '';
            if(!this.user.name){
                this.valid = false;
                this.errors.name = this.$trans.get('jobs.required');
            }else{
                this.checkform();      
                this.$store.commit('setSelected', { prop: 'user', value: this.user });
                return true;
            }
        },
        validphone(){
            this.errors.phone = '';
            if(!this.user.phone){
                this.valid = false;
                this.errors.phone = this.$trans.get('jobs.required');
            }else if(!this.isNumeric(this.user.phone)){
                this.valid = false;
                this.errors.phone = this.$trans.get('jobs.input_phone_invalid');
            }else if(this.user.phone.length !== 9){
                this.valid = false;
                this.errors.phone = this.$trans.get('jobs.input_phone_length');
            }else{
                this.checkform();
                this.$store.commit('setSelected', { prop: 'user', value: this.user });
                return true;
            }
        },
        isNumeric(input){
            return /^\d+$/.test(input);
        },
        validemail(){
            this.errors.email = '';
            if(!this.user.email){
                this.valid = false;
                this.errors.email = this.$trans.get('jobs.required');
            }else if(!this.checkEmail(this.user.email)){
                this.errors.email = this.$trans.get('jobs.inputemail');
            }else{
                this.checkform();
                this.$store.commit('setSelected', { prop: 'user', value: this.user });
                return true;
            }
        },
        validateEmailConfirmation(){
            this.errors.confirmEmail = '';
            if(this.user.email !== this.user.confirmEmail){
                this.valid = false;
                this.errors.confirmEmail = this.$trans.get('jobs.input_confirm_email');
            }else{
                this.checkform();
                this.$store.commit('setSelected', { prop: 'user', value: this.user });
                return true;
            }
        },
        checkEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        checkform(){
            if(this.user.name && this.user.email && this.checkEmail(this.user.email) && this.user.phone && this.user.email === this.user.confirmEmail){
                this.valid = true;
                return true;
            }
        },
        submmitform(){
            if(this.checkform() && this.privacyConsent){
                // this.$store.dispatch("saveUser", this.user);
                this.$router.push({ name: 'pago-para-la-preinscripcion' });
            }
        }
    },

}
</script>
<style lang="scss" scoped>
.form-account{
    max-width: 325px;
    margin: auto;
}
.text-red{
    color: red;
}
input[type="checkbox"] {
    visibility: hidden;
}
input[type="checkbox"] + label {
    display: block;
    cursor: pointer;
    margin-left: 2rem;
    p:first-child {
        padding-left: 1rem;
        margin-left: -1rem;
    }
}
input[type="checkbox"] + label:before {
    border: 1px solid #a5a9ad;
    border-radius: 6px;
    content: "\00a0";
    display: inline-block;
    font: 14px/1em sans-serif;
    width: 18px;
    height: 18px;
    margin: 2px .25em 0 0;
    padding: 1px 1px 0 0;
    position: absolute;
    left: -2rem;
}
input[type="checkbox"]:checked + label:before {
    background: #fff;
    color: #333;
    content: "\2713";
    text-align: center;
    font-weight: 600;
}
</style>
